import React from "react";

const DateInput = React.forwardRef(
	(
		{
			label,
			required,
			placeholder = "dd/mm/yyyy",
			hideLabel,
			error,
			onChange,
			value,
			name,
			onBlur,
			min,
			max,
		},
		ref
	) => {
		return (
			<div className="form-field">
				{!hideLabel && (
					<label className="field-label">
						{label}
						{required && <span className="required">*</span>}
					</label>
				)}

				<input
					ref={ref}
					type="date"
					placeholder={placeholder}
					required={required}
					className={error ? "error" : ""}
					name={name}
					value={value || ""}
					onChange={onChange}
					onBlur={onBlur}
					min={min}
					max={max}
				/>

				{error && <div className="field__error">{error.message}</div>}
			</div>
		);
	}
);

export default DateInput;
